import React from 'react'
import Smartview from 'widgets/smartviews/Smartview'
import SmartviewText from 'widgets/smartviews/partials/SmartviewText'
import * as UI from 'ui'
import * as Displays from 'support/displays'
import SmartviewTextGroup from 'widgets/smartviews/partials/SmartviewTextGroup'
import { Translation, Translator } from '@morningtrain/react-translations'
import { Collection, ForEachModel, WhenModelValue } from '@morningtrain/react-resources'
import { EnvFilter } from '../../../support/filters'

export default function RevenueByLocationSmartview () {
  return (
    <Translator namespace='smartviews.economy.revenue_by_location'>

      <Smartview size='sm' header={<Translation name='title'/>}>
        <Collection resourceName='economy' operationName='revenue_by_location'>
          <EnvFilter name='period' envKey='page.filters.period'/>
          <SmartviewTextGroup highlight highlightSize='card'>
            <ForEachModel>
              <SmartviewText>
                <UI.SpaceBetween>
                  <UI.Text weight='medium' size='base' color='black'>
                    <Displays.Text name='name'/>
                  </UI.Text>

                  <UI.Text size='base' align='right' color='black'>
                    <Displays.Currency name='revenue' decimals={0}/>
                    <WhenModelValue name='deviation_from_budget' condition={0} negate={true}>
                      <sup className='px-1'>
                        <Displays.Percentage
                          name='deviation_from_budget'
                          showPLusIfPositive={true}
                          badBelow={0}
                          decimals={0}
                          positiveColor='lightgreen'
                          showPlusIfPositive={true}
                        />
                      </sup>
                    </WhenModelValue>
                  </UI.Text>
                </UI.SpaceBetween>
              </SmartviewText>
            </ForEachModel>
          </SmartviewTextGroup>

        </Collection>
      </Smartview>
    </Translator>
  )
}
